


<div class="layout">
  <div class="pageList" *ngIf="!OnlyPageOne">

    <!-- <h4>  {{currentFormName}}</h4> -->

    <ul>  
      <li *ngFor="let steps of controlAlignArray;let i = index" (click)="GoToPage(steps.step)"
        [ngClass]="{'active' : (i + 1) == currentPage}">

        <!-- <mat-icon>article</mat-icon>  -->
        <span>{{i + 1}}</span>
        {{steps.pageName}}
        <mat-icon>chevron_right</mat-icon>
      </li>
    </ul>
  </div>

  <div class="pageWrapper" [ngStyle]="{'background-color': backgroundColorForm}">
    <div class="header" *ngIf="ShowHeader">
      <ng-container *ngFor="let item of HeaderFooter">
        <ng-container *ngIf="item.type=='Header'">
          <ng-container *ngFor="let img of item.ImageData" class="">
            <img class="bgimage" *ngIf='img.Imageurl' [src]="img.Imageurl" />
          </ng-container>
        </ng-container>
      </ng-container>

      <div class="detail">
        <h3 [ngStyle]="{'color': fontColor,'font-family': fontFamily,'font-size': fontHeaderSize}">{{headerText}}</h3>
      </div>
    </div>

    <div class="container">
      <div class="welcome" *ngIf="!OnlyPageOne">
        <!-- <button *ngIf="ShowFillForm"  id="fillFormsBtn" color="primary" class="nextBtn aboveRes" 
         mat-stroked-button  matTooltipClass="tooltip"     
         matTooltip="FILL FORM" (click)="fillForms(fillForm)">Fill Form
        </button> -->
        <div class="allSteps">
          <div class="nextPre">
            <select [(ngModel)]="currentStep" (change)="GoToPage($event.target.value)">
              <option *ngFor="let step of controlAlignArray" [value]="step.step">{{step.pageName}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="requestholder">

        <div class="info">

          <div class="formHolder">
            <div class="iframe-drag-bounds">
              <form autocomplete="off">
                <div class="" id="docSign" #content>

                  <div class="docSign">

                    <ng-container *ngFor="let data of FindCurrentStep(controlAlignArray);let i= index;"
                      style="width:100%">

                      <ng-container *ngFor="let item of data.fields;let i= index;">

                        <div
                          [ngClass]="[item.IsFullWidth === true ? 'fullWidth' : 'halfWidth', item.fieldJson.fieldTypeName == 'Feedback' ? 'feedback' : '', item.fieldJson.fieldTypeName == 'Rating' ? 'rating' : '']"
                          [ngClass]="getClass(item)">


                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Paragraph'">
                            <pre [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">{{item.fieldJson.selectedValue}}</pre>

                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='TextSingle'">
                            <p
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">
                              {{item.fieldJson.selectedValue}}
                            </p>

                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='TrueFalse'">
                            <span
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">{{item.fieldJson.selectedValue}}
                            </span>
                            <mat-radio-group style="display: grid" aria-label="Select an option">
                              <div class="" style="display:flex;">
                                <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px"
                                  [checked]="drp==item.fieldJson.radioSelectedValue"
                                  *ngFor="let drp of item.fieldJson.fillList" [value]="drp">
                                  {{drp}}
                                  <!-- <mat-icon *ngIf="drp=='True'">check</mat-icon>
                                  <mat-icon *ngIf="drp=='False'">close</mat-icon> -->
                                </mat-radio-button>
                              </div>

                            </mat-radio-group>
                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Rating'">
                            <span
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">{{item.fieldJson.selectedValue}}
                            </span>
                            <!-- <mat-radio-group style="display: grid" aria-label="Select an option">
                                <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px" *ngFor="let drp of item.fieldJson.fillList" [value]="drp">
                                 
                                <mat-icon *ngFor="let i of Arr(drp).fill(1)">star</mat-icon>
                                </mat-radio-button>
                              </mat-radio-group> -->

                            <div class="starRatingHolder">
                              <span *ngFor="let drp of item.fieldJson.fillList">
                                <span (click)="selectRating(drp,item,data)" [ngClass]="{'active': drp.active === true}">
                                  <mat-icon>star</mat-icon>
                                </span>
                              </span>
                            </div>


                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Feedback'">
                            <span
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">{{item.fieldJson.selectedValue}}
                            </span>
                            <!-- <mat-radio-group style="display: grid" aria-label="Select an option">
                                <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px" *ngFor="let drp of item.fieldJson.fillList" [value]="drp">
                                 
                                <mat-icon *ngFor="let i of Arr(drp).fill(1)">star</mat-icon>
                                </mat-radio-button>
                              </mat-radio-group> -->

                            <div class="starHolder">

                              <span *ngFor="let drp of item.fieldJson.fillList">
                                <span (click)="selectFeedback(drp,item,data)"
                                  [ngClass]="{'active': drp.active === true}">
                                  <mat-icon>task_alt</mat-icon>
                                  {{ drp.val}}
                                </span>
                              </span>

                            </div>


                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='URL'">
                            <a class="aHref" (click)="openVideoLink(item.fieldJson.selectedValue,showVideo)"
                              [ngStyle]="{ 'text-decoration': 'underline','cursor': 'pointer','color': '-webkit-link', 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight,'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">
                              {{item.fieldJson.fieldName}}
                            </a>

                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='MCQ'">
                            <span
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">{{item.fieldJson.selectedValue}}
                            </span>
                            <mat-radio-group style="display: grid" aria-label="Select an option">
                              <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px"
                                *ngFor="let drp of item.fieldJson.fillList" [value]="drp.val">
                                {{ drp.val }}</mat-radio-button>
                            </mat-radio-group>
                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Devider'">
                            <span
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">{{item.fieldJson.selectedValue}}
                            </span>
                            <span class="form-group-divider"
                              [ngStyle]="{
                              'display': 'block',
                              'background-color': 'grey',
                              'width': '100%',
                              'height': '2px',
                              'margin-top': '60px',
                              'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}">
                            </span>
                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Space'">
                            <span
                              [ngStyle]="{'display': 'block','height': (item.fieldJson.selectedValue == '' ? '1' : item.fieldJson.selectedValue)+'px'}">
                            </span>
                          </div>
                          <div [innerHTML]="item.fieldJson.selectedValue" class="controlContainer"
                            *ngIf="item.fieldJson.fieldTypeName=='HtmlEditor'">

                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Textbox'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <input type="text" class="form-control"
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                              maxlength="40" placeholder="{{item.fieldJson.fieldName}}"
                              [attr.value]='item.fieldJson.selectedValue'
                              (input)="onChanges($event.target.value,data,item)">
                          </div>
                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Textarea'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <textarea type="text" class="form-control" placeholder="{{item.fieldJson.fieldName}}"
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 
                             'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily,
                             'height': item.fieldJson.offsetHeight +'px'}" [innerHTML]='item.fieldJson.selectedValue'
                              (input)="onChanges($event.target.value,data,item)">
                            </textarea>
                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Number'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <input class="form-control" type="number" pattern="[0-9]+([\.,][0-9]+)?"
                              placeholder="{{item.fieldJson.fieldName}}"
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 
                              'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                              [attr.value]='item.fieldJson.selectedValue'
                              (input)="onChanges($event.target.value,data,item)">

                          </div>

                          <!-- <div class="controlContainer"  *ngIf="item.fieldJson.fieldTypeName=='Dropdown'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <mat-form-field appearance="outline">                        
                              <mat-select
                                [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                                placeholder={{item.fieldJson.selectedValue}} 
                                [(ngModel)]="item.fieldJson.selectedValue"                            
                                [attr.value]="item.fieldJson.selectedValue"
                                (selectionChange)="setDdlValue($event,data,item)">
    
                                <mat-option
                                  [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                                  maxlength="40" placeholder="{{item.fieldJson.fieldName}}"
                                  [attr.value]='item.fieldJson.selectedValue'
                                  (input)="onChanges($event.target.value,data,item)"
                                  >
                                  {{ drp.val }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
         -->
                          <!-- <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Textarea'">
                                <label>{{item.fieldJson.labelName}}</label>
                                <textarea type="text" class="form-control" placeholder="{{item.fieldJson.fieldName}}"
                                 [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 
                                 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily,
                                 'height': item.fieldJson.offsetHeight +'px'}" 
                                  [innerHTML]='item.fieldJson.selectedValue'
                                  (input)="onChanges($event.target.value,data,item)">
                                </textarea>
                              </div> 

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Number'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <input class="form-control" type="number" pattern="[0-9]+([\.,][0-9]+)?"
                              placeholder="{{item.fieldJson.fieldName}}"
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 
                                  'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                              [attr.value]='item.fieldJson.selectedValue'
                              (input)="onChanges($event.target.value,data,item)">

                          </div>-->

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Dropdown'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <!-- <mat-form-field appearance="outline">                        
                                  <mat-select
                                    [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                                    placeholder={{item.fieldJson.selectedValue}} 
                                    [(ngModel)]="item.fieldJson.selectedValue"                            
                                    [attr.value]="item.fieldJson.selectedValue"
                                    (selectionChange)="setDdlValue($event,data,item)">
        
                                    <mat-option
                                      [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                                      *ngFor="let drp of item.fieldJson.fillList" [value]="drp.val">
                                      {{ drp.val }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field> -->

                                <p>
                                  {{item.fieldJson.selectedValue}}
                                </p>
                            <!-- <select class="form-control"
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                              [(ngModel)]="item.fieldJson.selectedValue" (change)="setDdlValue($event,data,item)">
                              <option *ngFor="let drp of item.fieldJson.fillList" [value]="drp.val">{{ drp.val }}
                              </option>
                            </select> -->

                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Date'">
                            <label>{{item.fieldJson.labelName}}</label>

                            <div class="dateControl">
                              <input class="form-control"
                                [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize , 'font-family': item.fieldJson.fontfamily}"
                                [attr.Value]="item.fieldJson.selectedValue|date:'MM/dd/yyyy'"
                                placeholder={{item.fieldJson.fieldName}} readonly
                                (input)="onChangesDate($event.target.value,data,item)"
                                (dateChange)="onChangesDate($event.target.value,data,item)"
                                (click)="basicDatepicker.open()"
                                [matDatepicker]="basicDatepicker" />
                              <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                              <mat-datepicker #basicDatepicker></mat-datepicker>
                            </div>


                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Time'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <div class="dateControl">
                              <input class="form-control"
                                [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                                aria-label="default time" matInput placeholder={{item.fieldJson.fieldName}}
                                [attr.Value]='item.fieldJson.selectedValue' readonly>
                              <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker">
                              </ngx-material-timepicker-toggle>
                              <ngx-material-timepicker (timeSet)="onChanges($event,data,item)" #toggleTimepicker>
                              </ngx-material-timepicker>
                            </div>
                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Location'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <div class="customUpdate form-control" (click)="fetchLocation(data,item.id)">
                              <span *ngIf='!item.Lat && !item.Long'>
                                <mat-icon>location_on</mat-icon>
                                Location
                              </span>
                              <ng-container *ngIf='item.fieldJson.Lat && item.fieldJson.Long'>
                                <h3
                                  [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize , 'font-family': item.fieldJson.fontfamily}">
                                  Lat : {{item.fieldJson.Lat}}
                                  Long: {{item.fieldJson.Long}}
                                </h3>
                              </ng-container>

                            </div>
                          </div>

                          <div class="controlContainer specialButton" *ngIf="item.fieldJson.fieldTypeName=='Button'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <button mat-flat-button (click)="OpenlButtonLink(data,item.id,$event)"
                              [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily,
                              'background-color': item.fieldJson.backgroundColor}"
                              [value]='' color="primary" class="btnGlobal">{{item.fieldJson.buttonName}}</button>

                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Checkbox'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <div class="radioHolder">
                              <div *ngFor="let ele of item.fieldJson.fillList">
                                <label
                                  [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                                  class="checkboxItem">

                                  <input type="checkbox" [id]='item.fieldJson.id+ele.id'
                                    [checked]='ifChkChecked(item.fieldJson.id,data,ele.id)'
                                    [attr.checked]="ifChkChecked(item.fieldJson.id,data,ele.id)? 'checked' : null"
                                    (click)="OnChangeCheckBox($event,ele.val,item,data,ele.id)">
                                  {{ele.val}}

                                </label>
                              </div>
                            </div>

                          </div>

                          <div class="controlContainer " *ngIf="item.fieldJson.fieldTypeName=='Table'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <table class="formTable" style="border: 1px;">
                              <tbody>
                                <tr *ngFor="let row of item.fieldJson.rows;let r=index">
                                  <td *ngFor="let column of item.fieldJson.column;let c=index">
                                    <input class="form-control" id='{{item.id}}txt-{{r+1}}{{c+1}}'
                                      [attr.value]="getColumnValue(data,item.id,r+1,c+1)"
                                      (input)="onTableChange($event,data,item.id)" type="text"
                                      [ngStyle]="{'background-color':getTableBGValue(data,item.id,r+1,c+1)}"
                                      [disabled]="isTableCallDisable(data,item.id,r+1,c+1)" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                          </div>

                          <div class="controlContainer " *ngIf="item.fieldJson.fieldTypeName=='File'">
                            <label>{{item.fieldJson.labelName}}</label>
                            <div class=" customUpdate form-control">

                              <div *ngFor="let file of item.fieldJson.FileData" class="uploadedData">
                                <p>{{file.FullPath}}</p>
                              </div>

                              <span *ngIf='item.fieldJson.FileData.length==0'>
                                <mat-icon>cloud_upload</mat-icon>
                                Upload File

                              </span>


                              <input type="file" (change)="onSelectFile($event,data,item.id)" class="form-control"
                                placeholder="{{item.fieldName}}">

                            </div>


                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Signature'">
                            <label>{{item.fieldJson.labelName}}</label>

                            <div class="customUpdate form-control"
                              (click)="OpenSignPopup(AddSignature,data,item,$event)">

                              <span
                                *ngIf='!item.fieldJson.signatureBase64 && !item.fieldJson.signatureText && item.fieldJson.ImageData.length==0'>
                                <mat-icon>border_color</mat-icon>
                                Signature
                              </span>

                              <!-- Signature Stamp-->
                              <div class="sig-cell"
                                *ngIf='item.fieldJson.signatureBase64 || item.fieldJson.signatureText && !item.fieldJson.signatureBase64 || item.fieldJson.ImageData.length>0'
                                [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                <div class="sig-chrome"
                                  [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics
                                  </div>
                                  <div class="sig-container"
                                    [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                    <img *ngIf='item.fieldJson.signatureBase64'
                                      [src]="item.fieldJson.signatureBase64" />
                                    <ng-container
                                      *ngIf='item.fieldJson.signatureText && !item.fieldJson.signatureBase64'>
                                      <h3 [ngStyle]="{'font-family': item.fieldJson.signInitialFontFamily}">
                                        {{item.fieldJson.signatureText}}</h3>
                                    </ng-container>

                                    <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData"
                                      [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                      <img [src]="img.Imageurl" />
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>

                          <div class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Initials'">
                            <label>{{item.fieldJson.labelName}}</label>

                            <div class="customUpdate form-control" (click)="OpenSignPopup(AddInitial,data,item,$event)">
                              <span
                                *ngIf='!item.fieldJson.signatureBase64 && !item.fieldJson.signatureText && item.fieldJson.ImageData.length==0'>
                                <mat-icon>gesture</mat-icon>
                                Initials
                              </span>
                              <!-- Signature Stamp-->
                              <div class="sig-cell"
                                *ngIf='item.fieldJson.signatureBase64 || item.fieldJson.signatureText && !item.fieldJson.signatureBase64 || item.fieldJson.ImageData.length>0'
                                [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                <div class="sig-chrome"
                                  [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics
                                  </div>
                                  <div class="sig-container"
                                    [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                    <img *ngIf='item.fieldJson.signatureBase64'
                                      [src]="item.fieldJson.signatureBase64" />
                                    <ng-container
                                      *ngIf='item.fieldJson.signatureText && !item.fieldJson.signatureBase64'>
                                      <h3 [ngStyle]="{'font-family': item.fieldJson.signInitialFontFamily}">
                                        {{item.fieldJson.signatureText}}</h3>
                                    </ng-container>

                                    <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData"
                                      [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                      <img [src]="img.Imageurl" />
                                    </div>

                                  </div>

                                </div>
                              </div>

                            </div>
                          </div>


                          <div class="controlContainer " *ngIf="item.fieldJson.fieldTypeName=='Image'">
                            <label>{{item.fieldJson.labelName}}</label>

                            <div class="customUpdate form-control imageControl">
                              <span *ngIf='item.fieldJson.ImageData.length==0'>
                                <mat-icon>cloud_upload</mat-icon>
                                Upload Image
                              </span>

                              <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData">
                                <img *ngIf='img.Imageurl' [src]="img.Imageurl" />
                              </div>

                              <input type="file" class="form-control" (change)="onSelectImage($event,data,item.id)"
                                accept="image/*" placeholder="{{item.fieldJson.fieldName}}">
                            </div>
                          </div>

                          <div class="controlContainer " *ngIf="item.fieldJson.fieldTypeName=='embedImage'">
                            <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData">
                              <img *ngIf='img.Imageurl' [src]="img.Imageurl"
                                 />
                            </div>
                          </div>


                        </div>
                      </ng-container>

                    </ng-container>

                  </div>






                </div>
              </form>
            </div>

            <ng-container *ngIf="ShowFooter">
              <div class="footerBanner">
                <ng-container *ngFor="let item of HeaderFooter">
                  <ng-container *ngIf="item.type=='Footer'">
                    <ng-container *ngFor="let img of item.ImageData" class="">
                      <img class="bgimage" *ngIf='img.Imageurl' [src]="img.Imageurl" />
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>





          </div>



        </div>

      </div>

    </div>

    <div class="bottomStick">

      <div class="bottomNav">
        <ng-container *ngIf="currentStep >1">
          <button mat-stroked-button color="primary" [disabled]="!(currentStep>1)" matTooltip="Previous page"
            (click)="ChangeStep(1)">
            Previous
          </button>
        </ng-container>
        <ng-container *ngIf="currentStep ==1">
          <button mat-stroked-button color="primary" matTooltip="Previous page" (click)="cancel()">
            Cancel
          </button>
        </ng-container>


        <p class="submitBy">{{SubmitBy}}</p>

        <ng-container *ngIf="currentStep < controlAlignArray.length">
          <button mat-flat-button color="primary" matTooltip="Next Page" (click)="ChangeStep(2)">
            Next
          </button>
        </ng-container>

        <!-- <div class="stepAct" *ngIf="currentStep==controlAlignArray.length">
          <button *ngIf="!isFormTypeCheckIn" mat-flat-button color="primary" (click)="SubmitHTMLForm(AddEmail,formID)" matTooltip="Save">
            Finish & Submit
          </button>

          <button *ngIf="isFormTypeCheckIn && !isCheckIn" mat-flat-button color="primary" (click)="SubmitHTMLForm(AddEmail,formID)" matTooltip="checkIn">
            checkIn
          </button>
          <button *ngIf="isFormTypeCheckIn && isCheckIn" mat-flat-button color="primary" (click)="SubmitHTMLForm(AddEmail,formID)" matTooltip="checkOut">
            checkOut
          </button>

        </div> -->

      </div>

    </div>

  </div>

</div>


<ng-template #AddSignature>
  <h2 mat-dialog-title class="signTitle">
    <ng-container *ngIf="hasSignature">My Signature</ng-container>
    <ng-container *ngIf="!hasSignature">Adopt your signature</ng-container>

    <ng-container *ngIf="hasSignature">
      <button mat-flat-button class="addNewSignButton" color="primary" (click)="addNewSignature()"
        [disabled]="fiveSignaturesLimitReached">
        <mat-icon>add</mat-icon> Add signature
      </button>
    </ng-container>
    <ng-container *ngIf="!hasSignature">
      <button mat-stroked-button class="addNewSignButton" color="primary" (click)="addNewSignature()"
        [disabled]="fiveSignaturesLimitReached">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
    </ng-container>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">

      <!-- <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
          <mat-radio-button value="draw" (change)="radioChangeSign()">Draw</mat-radio-button>
          <mat-radio-button value="upload" (change)="radioChangeSign()">Upload</mat-radio-button>
          <mat-radio-button value="type" (change)="radioChangeSign()">Type In</mat-radio-button>
        </mat-radio-group>
      </div> -->



      <!-- <div class="allSCont">
        <ng-container *ngIf="signOpt == 'upload'">
          <div class="uploadholder">
            <mat-icon>note_add</mat-icon>
            <p *ngIf="filenameForSign == '' ">Drop your signature here or click here to upload</p>
            <span *ngIf="filenameForSign == '' ">File extension should be .png</span>
            <p>{{filenameForSign}}</p>
            <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
              placeholder="Add file">
          </div>
        </ng-container>

        <ng-container *ngIf="signOpt == 'draw'">
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
        </ng-container>

        <ng-container *ngIf="signOpt == 'type'">
          <div class="divideCol">
            <div class="left blk">
              <mat-form-field>
                <mat-label>Enter Name</mat-label>
                <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                  (ngModelChange)="signOrInitialTextChanges($event)">
              </mat-form-field>
            </div>
            <div class="right blk">
              <mat-form-field appearance="fill">
                <mat-label>Select font family</mat-label>
                <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                  <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="allSign">
            <div class="signlook" [ngStyle]="{'font-family': selected}">
              {{signName}}
            </div>
          </div>
        </ng-container>
      </div> -->


      <ng-container *ngIf="!hasSignature">
        <!-- new signature add options -->
        <div class="signatureOptions">

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'draw'}" (click)="signatureType('draw')">
            <div class="icon">
              <img src="./../../../assets/images/signature.png" alt="">
            </div>
            <div class="info">
              <h3>Draw your signature</h3>
              <p>Draw your signature here using your mouse or trackpad.</p>
            </div>
          </div>


          <div class="drawSignature" [ngClass]="{'active': signOpt == 'uploads'}" (click)="signatureType('upload')">
            <div class="icon">
              <img src="./../../../assets/images/uploadIcon.png" alt="">
            </div>
            <div class="info">
              <h3>Upload your signature</h3>
              <p>Upload an image on your handwritten signature here.</p>
            </div>
          </div>

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'type'}" (click)="signatureType('type')">
            <div class="icon">
              <img src="./../../../assets/images/typeIn.png" alt="">
            </div>
            <div class="info">
              <h3>Type in your signature</h3>
              <p>Add your name and select any font.</p>
            </div>
          </div>

        </div>
        <!-- new signature add options -->


        <!-- new signature Preview & Holder -->
        <div class="previewHolder">
          <h3 class="preview_text">PREVIEW</h3>
          <div class="previewContainer">
            <ng-container *ngIf="signOpt == 'upload'">
              <div class="uploadholderSignature">
                <!-- <mat-icon>note_add</mat-icon> -->
                <img src="./../../../assets/images/uploadIcon.png" alt="" width="60">
                <p *ngIf="filenameForSign == '' ">Upload your signature</p>
                <span *ngIf="filenameForSign == '' ">Upload an png image on your handwritten signature here</span>
                <p>{{filenameForSign}}</p>
                <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
                  placeholder="Add file">
              </div>
            </ng-container>

            <ng-container *ngIf="signOpt == 'draw'">
              <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"></signature-pad>
            </ng-container>

            <ng-container *ngIf="signOpt == 'type'">
              <div class="divideCol">
                <div class="left blk">
                  <mat-form-field>
                    <mat-label>Enter Name</mat-label>
                    <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                      (ngModelChange)="signOrInitialTextChanges($event)">
                  </mat-form-field>
                </div>
                <div class="right blk">
                  <mat-form-field appearance="fill">
                    <mat-label>Select font family</mat-label>
                    <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                      <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="allSign">
                <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                  {{signName}}
                </div>
                <style>
                  @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
                </style>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- new signature Preview & Holder -->
      </ng-container>



      <div *ngIf="hasSignature" class="signatureListHolder">

        <span class="limitReached" *ngIf="fiveSignaturesLimitReached">You can add upto 5 signatures only. Please delete
          a signature if you want to add new.</span>

        <div *ngFor="let img of getAllSignatures" class="signatureList">

          <div class="uploadedData"  (click)="selectedSignature(img)" [ngClass]="{ 'active': signatureID === img.signatureID || img.isDefault == true }">

            <mat-icon class="unselect">radio_button_unchecked</mat-icon>
            <mat-icon class="select">check_circle</mat-icon>

            <div class="sig-cell">
              <div class="sig-chrome">
                <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                <div class="sig-container">

                  <ng-container *ngIf="img.signature.type=='Draw'">
                    <div class="signature">
                      <img [src]="img.signature.signatureBase64" />
                    </div>
                  </ng-container>

                  <ng-container *ngIf="img.signature.type=='Upload'">
                    <div *ngFor="let img1 of img.signature.ImageData" class="signature">
                      <img [src]="img1.Imageurl" />
                    </div>
                  </ng-container>


                  <ng-container *ngIf="img.signature.type=='Type In'">
                    <div class="signature">
                      <h3 [ngStyle]="{'font-family': img.signature.signInitialFontFamily}">
                        {{img.signature.signatureText}}</h3>
                    </div>
                  </ng-container>

                </div>
                <div class="sig-chrome-title-bottom ng-binding">email id</div>
              </div>
            </div>

            <button mat-icon-button class="closeIcon" (click)="deleteSignature(img)"><mat-icon>close</mat-icon></button>
          </div>

        </div>
      </div>


    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <!-- <span>
      <button mat-stroked-button color="primary" *ngIf="signaturePad != undefined"
        (click)="clearSignature()">Clear</button>
      <button mat-flat-button (click)="addSignature()" color="primary" [disabled]="!SignButtonEnable">Sign</button>
    </span> -->

    <span>
      <button *ngIf="signOpt == 'draw' && !hasSignature" mat-stroked-button color="primary"
        (click)="clearSignature()">Clear</button>

      <!-- [disabled]="getAllSignatures.length==0" -->
      <button *ngIf="hasSignature" mat-flat-button (click)="addDefaultSignature()" color="primary">Adopt & Sign</button>

      <button *ngIf="!hasSignature" mat-flat-button (click)="addSignature()" color="primary"
        [disabled]="!SignButtonEnable">Adopt & Sign</button>
    </span>

  </mat-dialog-actions>
</ng-template>

<ng-template #AddInitial>
  <h2 mat-dialog-title class="signTitle">

    <ng-container *ngIf="hasInitials">My Initial</ng-container>
    <ng-container *ngIf="!hasInitials">Adopt your Initial</ng-container>

    <ng-container *ngIf="hasInitials">
      <button mat-flat-button class="addNewSignButton" color="primary" (click)="addNewInitial()"
        [disabled]="fiveInitialsLimitReached">
        <mat-icon>add</mat-icon> Add initial
      </button>
    </ng-container>
    <ng-container *ngIf="!hasInitials">
      <button mat-stroked-button class="addNewSignButton" color="primary" (click)="addNewInitial()"
        [disabled]="fiveInitialsLimitReached">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
    </ng-container>

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">

      <ng-container *ngIf="!hasInitials">
        <!-- new signature add options -->
        <div class="signatureOptions">

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'draw'}" (click)="signatureType('draw')">
            <div class="icon">
              <img src="./../../../assets/images/signature.png" alt="">
            </div>
            <div class="info">
              <h3>Draw your initial</h3>
              <p>Draw your initial here using your mouse or trackpad.</p>
            </div>
          </div>


          <div class="drawSignature" [ngClass]="{'active': signOpt == 'uploads'}" (click)="signatureType('upload')">
            <div class="icon">
              <img src="./../../../assets/images/uploadIcon.png" alt="">
            </div>
            <div class="info">
              <h3>Upload your initial</h3>
              <p>Upload an image on your handwritten initial here.</p>
            </div>
          </div>

          <div class="drawSignature" [ngClass]="{'active': signOpt == 'type'}" (click)="signatureType('type')">
            <div class="icon">
              <img src="./../../../assets/images/typeIn.png" alt="">
            </div>
            <div class="info">
              <h3>Type in your initial</h3>
              <p>Add your name and select any font.</p>
            </div>
          </div>

        </div>
        <!-- new signature add options -->


        <!-- new signature Preview & Holder -->
        <div class="previewHolder">
          <h3 class="preview_text">PREVIEW</h3>
          <div class="previewContainer">
            <ng-container *ngIf="signOpt == 'upload'">
              <div class="uploadholderSignature">
                <img src="./../../../assets/images/uploadIcon.png" alt="" width="60">
                <p *ngIf="filenameForSign == '' ">Upload your initial</p>
                <span *ngIf="filenameForSign == '' ">Upload an png image on your handwritten initial here</span>
                <p>{{filenameForSign}}</p>
                <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
                  placeholder="Add file">
              </div>
            </ng-container>

            <ng-container *ngIf="signOpt == 'draw'">
              <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"></signature-pad>
            </ng-container>

            <ng-container *ngIf="signOpt == 'type'">
              <div class="divideCol">
                <div class="left blk">
                  <mat-form-field>
                    <mat-label>Enter Name</mat-label>
                    <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                      (ngModelChange)="signOrInitialTextChanges($event)">
                  </mat-form-field>
                </div>
                <div class="right blk">
                  <mat-form-field appearance="fill">
                    <mat-label>Select font family</mat-label>
                    <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                      <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="allSign">
                <div class="signlook" [ngStyle]="{'font-family': signInitialFontFamily }">
                  {{signName}}
                </div>
                <style>
                  @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap';
                </style>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- new signature Preview & Holder -->
      </ng-container>



      <div *ngIf="hasInitials" class="signatureListHolder">

        <span class="limitReached" *ngIf="fiveInitialsLimitReached">You can add upto 5 initials only. Please delete a
          initials if you want to add new.</span>

        <div *ngFor="let img of getAllInitials" class="signatureList">

          <div class="uploadedData" [ngClass]="{ 'active': InitialsID === img.initialID || img.isDefault == true }">

            <mat-icon class="unselect">radio_button_unchecked</mat-icon>
            <mat-icon class="select">check_circle</mat-icon>

            <div class="sig-cell">
              <div class="sig-chrome">
                <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                <div class="sig-container" (click)="selectedInitials(img)">

                  <ng-container *ngIf="img.initial.type=='Draw'">
                    <div class="signature">
                      <img [src]="img.initial.signatureBase64" />
                    </div>
                  </ng-container>

                  <ng-container *ngIf="img.initial.type=='Upload'">
                    <div *ngFor="let img1 of img.initial.ImageData" class="signature">
                      <img [src]="img1.Imageurl" />
                    </div>
                  </ng-container>


                  <ng-container *ngIf="img.initial.type=='Type In'">
                    <div class="signature">
                      <h3 [ngStyle]="{'font-family': img.initial.signInitialFontFamily}">
                        {{img.initial.signatureText}}</h3>
                    </div>
                  </ng-container>

                </div>
                <div class="sig-chrome-title-bottom ng-binding">email id</div>
              </div>
            </div>

            <button mat-icon-button class="closeIcon" (click)="deleteInitails(img)"><mat-icon>close</mat-icon></button>
          </div>

        </div>
      </div>




    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <span>
      <button *ngIf="signOpt == 'draw' && !hasInitials" mat-stroked-button color="primary"
        (click)="clearInitail()">Clear</button>
      <!-- [disabled]="getAllInitials.length==0" -->
      <button *ngIf="hasInitials" mat-flat-button (click)="addDefaultInitials()" color="primary">Adopt & Sign</button>

      <button *ngIf="!hasInitials" mat-flat-button (click)="addInitails()" color="primary"
        [disabled]="!InitailButtonEnable">Adopt & Sign</button>
    </span>
  </mat-dialog-actions>
</ng-template>



<div class="progress-loader" *ngIf="spinner">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>

<ng-template #showVideo>
  <mat-dialog-content class="mat-typography">
    <ng-container>
      <iframe [src]='safeSrcVideo' width="560" height="315" frameborder="0" webkitallowfullscreen mozallowfullscreen
        allowfullscreen></iframe>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeVideo()">Cancel</button>
  </mat-dialog-actions>
</ng-template>


